import { Link2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface ProfileLink {
  url: string;
  title: string;
}

interface ProfileLinksProps {
  links: ProfileLink[];
  isEditing: boolean;
  onAddLink?: (link: ProfileLink) => void;
  newLink: ProfileLink;
  onNewLinkChange: (link: ProfileLink) => void;
}

const ProfileLinks = ({ 
  links, 
  isEditing, 
  onAddLink,
  newLink,
  onNewLinkChange 
}: ProfileLinksProps) => {
  return (
    <div className="space-y-2">
      {isEditing ? (
        <>
          <Label className="flex items-center gap-2">
            <Link2 className="w-4 h-4 text-purple-500" />
            Add Links
          </Label>
          <div className="flex gap-2">
            <Input
              value={newLink.title}
              onChange={(e) => onNewLinkChange({ ...newLink, title: e.target.value })}
              placeholder="Link Title"
              className="bg-white/90"
            />
            <Input
              value={newLink.url}
              onChange={(e) => onNewLinkChange({ ...newLink, url: e.target.value })}
              placeholder="URL"
              className="bg-white/90"
            />
            <Button onClick={() => onAddLink?.(newLink)} variant="outline">Add</Button>
          </div>
        </>
      ) : links.length > 0 && (
        <div className="space-y-2">
          <div className="flex items-center gap-2">
            <Link2 className="w-5 h-5 text-purple-500" />
            <h3 className="font-medium text-gray-900">Links</h3>
          </div>
          <div className="pl-7 space-y-2">
            {links.map((link, index) => (
              <a
                key={index}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-purple-600 hover:text-purple-700"
              >
                <Link2 className="w-4 h-4" />
                {link.title}
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileLinks;